import store from '../store/store.js';

const excludeRoutesNames = [
  'home-page',
  'home-changediary',
  'home-privacy-policy',
  'home-service-regulations',
  'privacy-policy',
  'changediary',
  'account-redirecting',
  'login',
  'rejestracja',
  'register',
  'invitation',
  'invitation',
  'forgot-password',
  'reset-password',
  'reset-password-link-expired',
  'page-error-401',
  'page-error-404',
  'mail-attachment',
];

export default async function crmNavigationMiddleware(to) {
  const parent = store.getters['auth/getActiveBossCompany']?.parent;
  if (!parent) {
    return;
  }

  if (excludeRoutesNames.includes(to.name)) {
    return;
  }

  await store.dispatch('CRM_NAVIGATION/rememberLastVisitedPage', {
    parent,
    path: to.fullPath,
    name: to.name,
  });
}
